import styled from 'styled-components'

import { ButtonPlain, stylesFrom } from '@subaio/components'

import { Row } from './Row'

export const RowButton = styled(ButtonPlain)`
	${stylesFrom(Row)}
	position: relative;

	outline: none !important;

	transition: background-color 0.15s;

	&:active {
		background-color: transparent;
	}
`
